import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { themeGet } from '@styled-system/theme-get';
import styled, { useTheme } from 'styled-components';
import { IRecommendationOptions } from '../../../logic/store/Plans/IRecommendationOptions';

const Pill = styled.div`
	background-color: #F0F0F0;
	color: ${themeGet('colors.mediumGrey')};
	border-radius: 14px;
	padding: 4px 16px 4px 16px;
	margin-right: 5px;
`;

export type ProductFilters = {
	RM: string;
	Irrigation: boolean;
	Fungicide: boolean;
	Traits: string | undefined;
};

export const AppliedProductFilters = (props: { filters: ProductFilters }) => 
{
	return (
		<div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', justifyContent: 'space-between' }}>
			{props.filters.Irrigation && <Pill> Irrigation: Yes </Pill>}
			{props.filters.Fungicide && <Pill> Fungicide: Yes </Pill>}
			<Pill> {props.filters.RM} </Pill>
			{props.filters.Traits && <Pill> {props.filters.Traits} </Pill>}
		</div>
	);
};


/** Convenience type for list of unique traits. */
type UniqueTrait = {
	traitName: string;
	traitId: string;
	traitFullName: string;
}

/** Given recommendation options, generate a productfilter ui object. */
export const filtersFromRecOptions = (uniqueTraits: UniqueTrait[], options: IRecommendationOptions): ProductFilters => 
{
	const selectedTraitNames = options.selectedTraits.length === 0 
		? undefined
		: options.selectedTraits.length > 1 && options.selectedTraits.length === uniqueTraits.length 
			// Just say all if all selected.
			? 'Traits: All'
			// Show the list if some selected.
			: `Traits: ${
				options.selectedTraits
					.map(t => uniqueTraits.find(ut => ut.traitId === t))
					.filter(Boolean)
					.map(t => t!.traitName)
					.join(', ')
			}`;

	return {
		RM: `RM: ${options.rmMin} - ${options.rmMax}`,
		Irrigation: options.irrigated,
		Fungicide: options.fungicide,
		Traits: selectedTraitNames,
	};
};
